import React from "react";

/**
 * Labeled on/off switch for settings panels (uses ds-toggle styles).
 *
 * @example
 * // Input — pressed=true, user clicks toggle
 * <SettingsToggleRow label="Show archived" pressed onChange={(next) => setVisible(next)} />
 * // Output — switch renders on; click calls onChange(false)
 */
const SettingsToggleRow = ({
  label,
  description = "",
  pressed = false,
  onChange,
  id,
}) => {
  const labelId = id || `settings-toggle-${String(label || "option").replace(/\s+/g, "-").toLowerCase()}`;

  return (
    <div className="ds-toggle-row">
      <div className="ds-toggle-row__copy">
        <div className="ds-toggle-row__label" id={labelId}>
          {label}
        </div>
        {description ? (
          <p className="ds-toggle-row__description">{description}</p>
        ) : null}
      </div>
      <button
        type="button"
        className={`ds-toggle${pressed ? " ds-toggle--on" : ""}`}
        role="switch"
        aria-checked={pressed}
        aria-labelledby={labelId}
        onClick={() => onChange?.(!pressed)}
      >
        <span className="ds-toggle__thumb" aria-hidden="true" />
      </button>
    </div>
  );
};

export default SettingsToggleRow;
